function getIsActive(progression, active, id) {
  if (progression === 'single' && active === id) {
    return [true, true];
  } else if (progression === 'accumulate' && id <= active) {
    return [true, active === id];
  }
  return [false, false];
}

export { getIsActive };
